import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { Observable } from 'rxjs';
import { RequestService } from 'app/core/services/request.service';
import { StepResult } from '../../catalog-modal.component';

@Component({
  selector: 'itpx-latter-step',
  templateUrl: './latter-step.component.html',
  styleUrls: ['./latter-step.component.css']
})
export class LatterStepComponent implements OnInit {

  @Output() saveFinished = new EventEmitter();
  @Output() stepBack: EventEmitter<any> = new EventEmitter();

  // @Input() catalogCode: string;
  // @Input() catalogName: string;
  @Input() results: StepResult[];
  @Input() url: string;
  @Input() sortStr: string = '';
  @Input() subtitle: string = '';
  @Input() stepIndex: number;
  @Input() isLastStep: boolean = false;
  @Input() firstStepSkipped: boolean = false;
  @Input() displayIcon: boolean = false;



  constructor(
    // private service: ProductSellerService,
    private modalService: SmartModalService,
    private requestService: RequestService,
  ) { }

  data$: Observable<any>;
  finalStepResultDict: any[];


  ngOnInit() {
    this.data$ = this.requestService.get(this.constructUrl())
      .map(body => body.data)
      .map(res => {
        if (this.isLastStep)
          this.finalStepResultDict = res;
        return res.map(r => { return { id: r.id || r.key, value: r.title || r.value, icon: r.imageSvg } })
      });
    // this.topics$.subscribe(res => console.log(res))


  }

  private onTileClicked(e: any) {
    if (this.isLastStep) {
      let category = this.finalStepResultDict.find(cat => cat.key === e.id);
      let modalresult = { id: category.key, name: category.value }
      this.modalService.sendResult(modalresult);
    }
    else
      this.saveFinished.emit({ id: e.id, title: e.value } as StepResult)
  }
  cropText(t): string {
    if (t) {
      return t.substring(0, 22);
    }
  }

  back(to: number) {
    // let templateKey = 'main-category-select-template';
    this.stepBack.emit({ to: to });
  }

  onCancel() {
    this.modalService.close()
  }

  constructUrl() {
    let res = this.url + '/' + this.results[this.results.length - 1].id;
    if (this.results.length === 2) {
      res += '?catalogCode=' + this.results[this.results.length - 2].id
    }
    res += this.sortStr;
    return res;
  }
}





// WEBPACK FOOTER //
// ./src/app/shared/components/modal/catalog-modal/steps/latter-step/latter-step.component.ts